import store from '@/store/store.js'

/**
 * Check if user has the specified beta flag
 * @param {string} betaFlag
 */
export const betaGuard = (betaFlag, failRoute) => (
  /** @type {import('node_modules/vue-router/types/index').Route} */ _to,
  /** @type {import('node_modules/vue-router/types/index').Route} */ _from,
  /** @type {import('node_modules/vue-router/types/index').NavigationGuardNext} */ next,
) => {
  if (!store.getters.user?.enabled_beta_features.includes(betaFlag)) {
    next({ name: failRoute, query: _to.query })
  } else {
    next()
  }
}
